const FIELD_LABELS: Record<string, string> = {
  gradiliste_id: "Gradilište", dobavljac_id: "Dobavljač", svrha: "Svrha",
  okvirni_iznos: "Okvirni iznos", cijena: "Cijena", jedinica: "Jedinica",
  rok_isporuke: "Rok isporuke", mjesto_isporuke: "Mjesto isporuke",
  poslano_biljeska: "S kim dogovoreno", biljeska: "Bilješka", poruka: "Poruka",
  razlog: "Razlog", otpremnica: "Otpremnica", bez_otpremnice_razlog: "Razlog primitka bez otpremnice",
  nabava_prag_odobrenja: "Prag odobrenja", nabava_pocetni_broj: "Početni broj narudžbenice",
  record_id: "Postojeći strukturirani zapis", correction_reason: "Razlog ispravka povijesne verzije",
  employment_type: "Vrsta zaposlenja", contract_type: "Vrsta ugovora",
  contract_start_on: "Početak ugovora", contract_end_on: "Kraj ugovora",
  document_type_code: "Tip dokumenta", mode: "Način strukturirane potvrde",
  datum_izdavanja: "Datum izdavanja zapisa", datum_isteka: "Datum isteka zapisa",
  issued_on: "Datum izdavanja", expires_on: "Datum isteka",
  ocjena: "Ocjena sposobnosti", vrsta_pregleda: "Vrsta pregleda",
  datum_pregleda: "Datum pregleda", datum_sljedeceg_pregleda: "Datum sljedećeg pregleda",
  pur_posao_id: "PUR posao", vrsta_id: "Vrsta osposobljavanja", status: "Status osposobljavanja",
  dogadaj_okidac: "Događaj okidač", datum_osposobljavanja: "Datum osposobljavanja",
  nadzor_pocetak: "Početak nadzora", vrsta_izvorni_tekst: "Izvorni naziv vrste",
  vrsta_ozo_id: "Vrsta OZO-a", datum_zaduzenja: "Datum zaduženja", rok_zamjene: "Rok zamjene",
  kolicina: "Količina", velicina: "Veličina", zaduzio_text: "Zadužio", napomena: "Napomena",
  broj_dozvole: "Broj dozvole", broj_dokumenta: "Broj isprave", izdavatelj: "Izdavatelj",
  zemlja_iso2: "Zemlja", zemlja_izdavanja_iso2: "Zemlja izdavanja",
  kategorije: "Kategorije vozačke dozvole", kategorija: "Kategorija vozačke dozvole",
  tip: "Tip kvalifikacije", naziv: "Naziv", radnik_id: "Radnik",
};

export function validationFieldLabel(path: string): string {
  const parts = path.split(".");
  const label = FIELD_LABELS[parts.at(-1) ?? path] ?? "Polje za dopunu";
  if (parts[0] === "kategorije" && /^\d+$/.test(parts[1] ?? "")) return `${label} · kategorija ${Number(parts[1]) + 1}`;
  return label;
}

export function missingFieldNames(detail: unknown): string[] {
  if (!detail || typeof detail !== "object" || !("missing_fields" in detail) || !Array.isArray(detail.missing_fields)) return [];
  return detail.missing_fields.filter((field): field is string => typeof field === "string");
}
